import React from 'react';
import { BsClipboard } from 'react-icons/bs';

import { alert } from 'lib/alert';

import { CopyBox, SmallAction } from './setup-wizard.styles';

interface CopyableValueProps {
  value: string;
  /** Mensagem do aviso de sucesso ("Endereço copiado!"). */
  copiedMessage?: string;
  label?: string;
}

/**
 * Valor em destaque com botão "Copiar" — e-mail de compartilhamento da marca,
 * endereço EnergyPass e código da distribuidora no assistente (out/2026).
 */
export const CopyableValue = ({
  value,
  copiedMessage = 'Copiado!',
  label = 'Copiar',
}: CopyableValueProps) => (
  <CopyBox>
    <code>{value}</code>
    <SmallAction
      type="button"
      onClick={() =>
        navigator.clipboard
          ?.writeText(value)
          .then(() => alert.success(copiedMessage))
          .catch(() => {
            /* clipboard indisponível — o valor está na tela */
          })
      }
    >
      <BsClipboard />
      {label}
    </SmallAction>
  </CopyBox>
);
